import { SC } from "../helper/ServerCall";
import { pathSegment } from "../helper/queryString";

export const accountService = {
    getBrands,
    getBrandingInfoById,
    getBrandingInfoBySlug,
    getBrandsCamerasToShip,
}

function getBrands() {
    return SC.getCall('getBrands');
}


function getBrandsCamerasToShip() {
    return SC.getCall('getBrandsCameraToShip');
}

function getBrandingInfoById(id) {
    return SC.getCall(`getBrandingInfo/${pathSegment(id)}`);
}

function getBrandingInfoBySlug(slug) {
    return SC.getCall(`getBrandingInfoBySlug/${pathSegment(slug)}`);
}
